<app-dashboard-layout [notDashboard]="true" [loading]="loading || skeletonLoader">
  <section class="bg-white border rounded-md p-4">
    <header class="border-b flex text-lg w-full pb-6 pb-4 gap-8 md:text-xl">
      Basic Biodata Info
    </header>

    <div *ngIf="skeletonLoader" class="max-w-screen-md grid pb-4 gap-4 grid-cols-1 md:gap-8 md:grid-cols-2">
      <div *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" class="border rounded-md bg-gray-300 h-20 animate-pulse"></div>
    </div>

    <form ngNativeValidate *ngIf="!skeletonLoader" id="biodata-basic" class="max-w-screen-md grid gap-8 grid-cols-1"
      (ngSubmit)="updateBiodata()">
      <app-notification-alert [data]="notification"></app-notification-alert>
      <!-- <div *ngIf="!isDisabled"> -->
      <div *ngIf="true">
        <div class="grid gap-8 grid-cols-1 md:grid-cols-2">

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              Surname *
            </div>
            <input [disabled]="!_isApplication" type="text" name="surname" placeholder="Surname" [ngModel]="payload.Surname"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              First Name *
            </div>
            <input [disabled]="!_isApplication" type="text" name="firstName" placeholder="First Name" [ngModel]="payload.FirstName"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Middle Name
            </div>
            <input [disabled]="!_isApplication" type="text" name="middleName" placeholder="Middle Name" [ngModel]="payload.MiddleName"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              Nationality *
            </div>

            <input *ngIf="payload.Nationality" [disabled]="!_isApplication" type="text" name="Nationality" placeholder="Nationality"
              [ngModel]="payload.Nationality"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
            <div *ngIf="countries && !payload.Nationality"
            class="border border-primary-lighter rounded text-sm w-full py-1 px-2 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light">
              <select *ngIf="!payload.Nationality" class="w-full p-1 focus:outline-none"
                [(ngModel)]="payload.Nationality">
                <option disabled value="">Select a country</option>
                <option *ngFor="let country of countries" [value]="country.CountryID">
                  {{ country.Name }}
                </option>
              </select>
            </div>
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              State Of Origin *
            </div>

            <input *ngIf="payload.StateOfOrigin" [disabled]="!_isApplication" type="text" name="StateOfOrigin" placeholder="State"
              [ngModel]="payload.StateOfOrigin"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
            <div *ngIf="states && !payload.StateOfOrigin"
            class="border border-primary-lighter rounded text-sm w-full py-1 px-2 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light">
              <select *ngIf="!payload.StateOfOrigin" class="w-full p-1 focus:outline-none"
                [(ngModel)]="payload.StateOfOrigin" (ngModelChange)="onStateChange()">
                <option disabled value="">Select a state</option>
                <option *ngFor="let state of states" [value]="state.StateID">
                  {{ state.Name }}
                </option>
              </select>
            </div>
          </label>

          

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              LGA *
            </div>

            <input *ngIf="payload.LocalGovernmentArea" [disabled]="!_isApplication" type="text" name="LocalGovernmentArea" placeholder="LGA"
              [ngModel]="payload.LocalGovernmentArea"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
            <div *ngIf="localGovts && !payload.LocalGovernmentArea"
            class="border border-primary-lighter rounded text-sm w-full py-1 px-2 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light">
              <select *ngIf="!payload.LocalGovernmentArea" class="w-full p-1 focus:outline-none"
                [(ngModel)]="payload.LocalGovernmentArea">
                <option disabled value="">Select LGA</option>
                <option *ngFor="let LGA of localGovts" [value]="LGA.LocalGovtID" [selected]="LGA.LocalGovtID == payload.LocalGovernmentArea">
                  {{ LGA.Name }}
                </option>
              </select>
            </div>
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Date of Birth *
            </div>
            <input [disabled]="!_isApplication && !_checks.ChangeDateOfBirthAllowed" type="date" name="DateOfBirth" placeholder="" [(ngModel)]="payload.DateOfBirth"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              Gender *
            </div>

            <div
              class="border border-primary-lighter rounded text-sm w-full py-1 px-2 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light">
              <select name="Gender" [(ngModel)]="payload.Gender" class="w-full p-1 focus:outline-none">
                <option disabled value="">Select option</option>
                <option *ngFor="let item of DTOs.Gender" [selected]="item == payload.Gender">
                  {{ item }}
                </option>
              </select>
            </div>
          </label>

          <label [hidden]="_isApplication" class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              Religion *
            </div>

            <div
              class="border border-primary-lighter rounded text-sm w-full py-1 px-2 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light">
              <select name="Religion" [(ngModel)]="payload.Religion" class="w-full p-1 focus:outline-none">
                <option disabled value="">Select option</option>
                <option *ngFor="let item of DTOs.Religion" [selected]="item == payload.Religion">
                  {{ item }}
                </option>
              </select>
            </div>
          </label>
          
          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Place Of Birth
            </div>
            <input type="text" name="PlaceOfBirth" placeholder="Place of birth" [(ngModel)]="payload.PlaceOfBirth"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>
        </div>
        <h5 class="my-5">Contact Information</h5>
          
        <div class="grid gap-8 grid-cols-1 md:grid-cols-2">
          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Contact Email *
            </div>
            <input type="text" name="Email" placeholder="Email" [(ngModel)]="payload.Email"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>
          
          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Contact Phone Number
            </div>
            <input type="text" name="Mobile" placeholder="Telephone Number" [(ngModel)]="payload.Mobile"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>
          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Street Name *
            </div>
            <input type="text" name="HomeAddress" placeholder=" Permanent Home Address " [(ngModel)]="payload.HomeAddress"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>
          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              City
            </div>
            <input type="text" name="City" placeholder="City" [(ngModel)]="payload.City"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              State
            </div>

            <div
              class="border border-primary-lighter rounded text-sm w-full py-1 px-2 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light">
              <select name="StateAddress" [(ngModel)]="payload.StateAddress" class="w-full p-1 focus:outline-none">
                <option disabled value="">Select state</option>
                <option *ngFor="let state of states" [value]="state.StateID" [selected]="state.StateID == payload.StateAddress">
                  {{ state.Name }}
                </option>
              </select>
            </div>
          </label>

          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2 block">
              Who does the child live with
            </div>

            <div
              class="border border-primary-lighter rounded text-sm w-full py-1 px-2 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light">
              <select name="ChildLeavingWith" [(ngModel)]="payload.ChildLeavingWith" class="w-full p-1 focus:outline-none">
                <option disabled value="">Select option</option>
                <option *ngFor="let item of DTOs.ChildLeavingWith" [value]="item" [selected]="item == payload.ChildLeavingWith">
                  {{ item }}
                </option>
              </select>
            </div>
          </label>
          
          <!-- <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Previous School
            </div>
            <input type="text" name="PreviousSchool" placeholder="PreviousSchool" [(ngModel)]="payload.PreviousSchool"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>
          
          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Prev. School date
            </div>
            <input type="date" name="PreviousSchoolDate" placeholder="" [(ngModel)]="payload.PreviousSchoolDate"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label>
          
          <label class="block">
            <div class="font-medium text-grey-darker text-sm mb-2">
              Class In Previous School
            </div>
            <input type="text" name="ClassInPreviousSchool" placeholder="" [(ngModel)]="payload.ClassInPreviousSchool"
              class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
          </label> -->

          
        </div>

      </div>
      <div class="grid gap-8 grid-cols-1 md:grid-cols-2">

      </div>

      <nav class="flex flex-col py-6 gap-4 justify-center">
        <app-button-primary type="submit" [disabled]="loading" class="mx-auto max-w-screen-sm w-full">
          UPDATE BIODATA
        </app-button-primary>

        <app-notification-alert [data]="notification"></app-notification-alert>
      </nav>
    </form>
  </section>
</app-dashboard-layout>